<template>
  <div id="smartHeatFullScreen" @click="closeSelf">
    <el-image
      class="bgImgCls"
      style="width: 100%; height: 100%"
      fit="fill"
      :src="bgImg"
    ></el-image>
    <el-image class="titleBgCls" fit="fill" :src="titleBgImg"></el-image>
    <div class="pickerDateBox">
      <el-image
        class="leftCls"
        fit="fill"
        :src="require('@/assets/leftArrow.png')"
        @click.stop="leftAction"
      ></el-image>
      <div class="dateCls" @click.stop="pickerDateAction">
        <el-date-picker
          ref="pickerDate"
          class="datePicker"
          v-model="selectedDate"
          type="date"
          format="yyyy.MM.dd"
          placeholder="选择日期"
          :clearable="false"
          :editable="false"
          @change="selectedDateAction"
        ></el-date-picker>
        <div class="dateShow">{{ selectedDateStr }}</div>
      </div>
      <el-image
        class="rightCls"
        fit="fill"
        :src="require('@/assets/rightArrow.png')"
        @click.stop="rightAction"
      ></el-image>
    </div>
    <div class="chartsBoxCls" :style="chartsStyle" ref="chartsBox">
      <div
        class="chartItemBox"
        v-for="(chartItemData, index) in chartsData"
        :key="index"
        @click.stop="previewChart(chartItemData)"
      >
        <el-image
          style="width: 100%; height: 100%;"
          fit="fill"
          :src="chartItemData.noneBgImg"
        ></el-image>
        <div
          v-if="chartItemData.type == 'setTempEquipment'"
          class="chartTitleBox"
          :style="chartTitleStyle"
        >
          <div class="titleCls">
            <div :style="roomTextStyle">
              {{ chartItemData.houseStructureDetail }}
            </div>
            <div :style="roomTextStyle">{{ chartItemData.name }}</div>
          </div>
          <div
            class="runStatus"
            :style="runStatusColor(chartItemData.statusCode)"
          >
            <div :style="chartStatusStyle">{{ chartItemData.runStatus }}</div>
          </div>
        </div>
        <div
          class="maxAndMinTemp"
          v-if="chartItemData.type == 'boiler' && !isNowDate"
        >
          <span class="maxTempCls">室外最高温度: {{ maxOutDoorTemp }}℃</span>
          <span>室外最低温度: {{ minOutDoorTemp }}℃</span>
        </div>
        <div class="chartBoxCls" v-if="chartItemData.type == 'boiler'">
          <smart-gas-temp-chart
            v-if="isNowDate"
            :chartData="chartItemData"
            :equipmentData="chartsData.length > 1 ? chartsData[1] : null"
          ></smart-gas-temp-chart>
          <gas-temp-bar-chart
            v-if="!isNowDate"
            :xData="[chartItemData.date]"
            :gasData="[chartItemData.gasQuantity]"
          ></gas-temp-bar-chart>
        </div>
        <div
          class="chartBoxCls"
          v-if="chartItemData.type == 'setTempEquipment'"
        >
          <smart-equipment-chart
            :equipmentData="chartItemData"
          ></smart-equipment-chart>
        </div>
      </div>
    </div>
    <equipment-popup
      class="equipmentPopup"
      v-if="isShowEquipmentPopup"
      :chartData="selectedChartData"
      @closeEquipmentPopup="closeEquipmentPopUpAction"
    ></equipment-popup>
    <gas-temp-popup
      class="gasTempPopup"
      v-if="isShowGasTempPopup"
      :chartData="selectedChartData"
      :equipmentData="chartsData.length > 1 ? chartsData[1] : null"
      :selectedDateStr="selectedDateStr"
      :isNowDate="isNowDate"
      :maxOutDoorTemp="maxOutDoorTemp"
      :minOutDoorTemp="minOutDoorTemp"
      @closeGasTempPopup="closeGasTempPopupAction"
    ></gas-temp-popup>
  </div>
</template>
<script>
import EquipmentPopup from "./equipmentChartPopup.vue";
import GasTempPopup from "./gasTempPopup.vue";
import SmartEquipmentChart from "@/components/subComponents/smartEquipmentChart.vue";
import SmartGasTempChart from "@/components/subComponents/smartGasTempChart.vue";
import GasTempBarChart from "@/components/subComponents/smartGasTempBarChart.vue";
export default {
  name: "smartHeat",
  components: {
    EquipmentPopup,
    GasTempPopup,
    SmartEquipmentChart,
    SmartGasTempChart,
    GasTempBarChart,
  },
  data() {
    return {
      isShowDatePicker: false,
      isShowEquipmentPopup: false,
      isShowGasTempPopup: false,
      selectedChartData: Object,
      bgImg: require("@/assets/bg.png"),
      titleBgImg: require("@/assets/titleBg.png"),
      selectedDate: Date,
      selectedDateStr: "",
      columnNum: 2,
      chartTitleStyle: {},
      chartStatusStyle: {},
      roomTextStyle: {},
      dataSource: [],
    };
  },
  watch: {},
  computed: {
    chartsStyle() {
      var styleObj = {
        gridTemplateColumns: `repeat(${this.columnNum}, minmax(100px, 1fr))`,
      }
      if (this.columnNum == 2 && this.chartsData.length <= 2) {
        styleObj.height = `400px`;
      }
      if (this.columnNum == 3 && this.chartsData.length == 3) {
        styleObj.gridTemplateRows = `1fr 1fr`;
      }
      return styleObj;
    },
  },
  props: {
    chartsData: Array,
    isNowDate: true,
    selectedDay: null,
    maxOutDoorTemp: 0,
    minOutDoorTemp: 0,
  },
  created() {
    if (this.chartsData.length <= 8 && this.chartsData.length >= 3) {
      this.columnNum = 3;
    }
    if (this.chartsData.length > 8 && this.chartsData.length <= 12) {
      this.columnNum = 4;
    }
    if (this.chartsData.length > 12) {
      this.columnNum = Math.floor(this.chartsData.length / 3) + 1;
    }
  },
  methods: {
    setChartTitleStyle() {
      var numFlag1 = this.chartsData.length / this.columnNum;
      var numFlag2 = Math.floor(this.chartsData.length / this.columnNum);
      var rowNum = numFlag2 < numFlag1 ? numFlag2 + 1 : numFlag1;
      if (this.$refs.chartsBox == undefined) return;
      var chartsBoxHeight = this.$refs.chartsBox.offsetHeight;
      var chartItemHeight = Math.ceil(chartsBoxHeight / rowNum) - 40;
      var titleBoxHeight = (chartItemHeight * 10) / 100;
      if (titleBoxHeight - 8 > 12) return;
      var titleFontSize = titleBoxHeight - 8 < 12 ? 12 : titleBoxHeight - 8;
      var transFrom =
        titleBoxHeight - 8 < 12
          ? "scale(" +
            (titleBoxHeight - 8) / 12 +
            "," +
            (titleBoxHeight - 8) / 12 +
            ")"
          : "scale(1,1)";
      var statusTransfrom =
        titleBoxHeight - 8 < 12
          ? "scale(" +
            (titleBoxHeight - 4) / 12 +
            "," +
            (titleBoxHeight - 4) / 12 +
            ")"
          : "scale(1,1)";
      this.chartTitleStyle = {
        height: titleBoxHeight + "px",
        fontSize: titleFontSize + "px",
      };
      this.roomTextStyle = {
        fontSize: titleFontSize + "px",
        transform: transFrom,
      };
      this.chartStatusStyle = {
        fontSize: titleFontSize + "px",
        transform: statusTransfrom,
      };
    },
    //关闭机电设备图表预览弹窗
    closeEquipmentPopUpAction() {
      this.isShowEquipmentPopup = false;
    },
    //关闭气量和温度图表预览弹窗
    closeGasTempPopupAction() {
      this.isShowGasTempPopup = false;
    },
    previewChart(chartItem) {
      if (this.isShowDatePicker) {
        this.isShowDatePicker = false;
        return;
      }
      this.selectedChartData = chartItem;
      if (chartItem.type == "boiler") {
        this.isShowGasTempPopup = true;
        return;
      }
      this.isShowEquipmentPopup = true;
    },
    leftAction() {
      var selectedDateseconds = this.selectedDate.getTime();
      var date = new Date(selectedDateseconds - 24 * 60 * 60 * 1000);
      var beforeDay =
        date.getDate().toString().length == 1
          ? "0" + date.getDate()
          : date.getDate();
      var newMonth = (date.getMonth() + 1).toString();
      newMonth = newMonth.length == 1 ? "0" + newMonth : newMonth;
      var newYear = date.getFullYear();
      this.$set(this, "selectedDate", date);
      this.$set(
        this,
        "selectedDateStr",
        newYear + "." + newMonth + "." + beforeDay
      );
      //重新请求数据
      this.$emit("changeDateAction", this.selectedDate);
    },
    rightAction() {
      var selectedDateseconds = this.selectedDate.getTime();
      var date = new Date(selectedDateseconds + 24 * 60 * 60 * 1000);
      var nextDay =
        date.getDate().toString().length == 1
          ? "0" + date.getDate()
          : date.getDate();
      var newMonth = (date.getMonth() + 1).toString();
      newMonth = newMonth.length == 1 ? "0" + newMonth : newMonth;
      var newYear = date.getFullYear();
      this.$set(this, "selectedDate", date);
      this.$set(
        this,
        "selectedDateStr",
        newYear + "." + newMonth + "." + nextDay
      );
      //重新请求数据
      this.$emit("changeDateAction", this.selectedDate);
    },
    pickerDateAction() {
      this.isShowDatePicker = true;
      this.$refs.pickerDate.focus();
    },
    runStatusColor(statusCode) {
      if (statusCode == 3) {
        return "color: #FF4B82";
      }
      return "color: #4BCEFF";
    },
    closeSelf() {
      if (this.isShowDatePicker) {
        this.isShowDatePicker = false;
        return;
      }
      this.isShowEquipmentPopup = false;
      this.isShowGasTempPopup = false;
      this.$emit("closeFullScreenWindow");
    },
    //选择了日期
    selectedDateAction() {
      var newYear = this.selectedDate.getFullYear();
      var newMonth = (this.selectedDate.getMonth() + 1).toString();
      var newDay = this.selectedDate.getDate().toString();
      newMonth = newMonth.length == 1 ? "0" + newMonth : newMonth;
      newDay = newDay.length == 1 ? "0" + newDay : newDay;
      this.$set(
        this,
        "selectedDateStr",
        newYear + "." + newMonth + "." + newDay
      );
      //重新请求数据
      this.$emit("changeDateAction", this.selectedDate);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setChartTitleStyle();
    });
    var nowYear = this.selectedDay.getFullYear();
    var nowMonth = this.selectedDay.getMonth() + 1 + "";
    var nowDay = this.selectedDay.getDate();
    if (nowMonth.length == 1) {
      nowMonth = "0" + nowMonth;
    }
    if (nowDay.length == 1) {
      nowDay = "0" + nowDay;
    }
    this.selectedDate = this.selectedDay;
    this.selectedDateStr = nowYear + "." + nowMonth + "." + nowDay;
  },
};
</script>

<style scoped>
#smartHeatFullScreen {
  width: 100vw;
  height: 100vh;
  background-color: white;
  position: relative;
  overflow: hidden;
}
.titleBgCls {
  width: 100%;
  height: 100px;
  color: white;
  position: absolute;
  top: 20px;
  left: 0;
}
.chartsBoxCls {
  width: 100%;
  position: absolute;
  top: 240px;
  bottom: 80px;
  display: grid;
}
.chartItemBox {
  position: relative;
  margin: 20px 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.chartTitleBox {
  position: absolute;
  height: 28px;
  top: 10px;
  right: 17%;
  left: 37%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: start;
}
.titleCls,
.runStatus {
  display: inline-block;
  height: 100%;
  line-height: 100%;
}
.titleCls {
  width: 80%;
  text-align: left;
  color: #4bceff;
}
.titleCls div {
  font-size: 12px;
  display: inline-block;
}
.runStatus {
  width: 18%;
  font-size: 14px;
  text-align: center;
}
.pickerDateBox {
  position: absolute;
  width: 100%;
  top: 100px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dateCls {
  position: relative;
  width: 10%;
}
.datePicker {
  width: 100%;
  height: 100%;
  opacity: 0;
}
.dateShow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4bceff;
  font-size: 1.2rem;
}
.dateShow:hover {
  cursor: pointer;
}
.leftCls,
.rightCls {
  width: 30px;
  height: 30px;
}
.leftCls {
  right: 10px;
}
.rightCls {
  left: 10px;
}
.leftCls:hover {
  cursor: pointer;
}
.rightCls:hover {
  cursor: pointer;
}
.equipmentPopup,
.gasTempPopup {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.chartBoxCls {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 10px;
  z-index: 4;
}
.maxAndMinTemp {
  font-size: 12px;
  position: absolute;
  z-index: 3;
  height: 10%;
  top: 5%;
  width: 100%;
  color: #4bceff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.maxTempCls {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartSystems/smartHeatFullScreen.vue